import React from 'react';
import { FadeIn } from './FadeIn';
const faqs = [{
  q: 'Do I need to buy expensive equipment?',
  a: 'No. These are biological shifts using items you already have at home.'
}, {
  q: 'Is this just for women?',
  a: 'No. Men experience significant cortisol-driven sleep disruption after 45; this protocol addresses both.'
}, {
  q: "Can I listen to this while I'm already in bed?",
  a: 'Yes, Track 6 is designed specifically to be played while you are lying in the dark.'
}, {
  q: 'How soon will I see results?',
  a: 'Most users report a significantly "calmer" night within the first 48 hours of implementing the temperature reset.'
}];
export function FAQ() {
  return <section className="py-24 md:py-32 bg-[#0B1029] relative" data-id="element-45">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-46">
        <FadeIn data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16 text-white" data-id="element-48">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-49">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-50">
              <div className="bg-white/[0.02] p-6 md:p-8 rounded-2xl border border-white/5 hover:bg-white/[0.04] transition-colors" data-id="element-51">
                <h4 className="text-xl font-medium text-[#F5D0A9] mb-3" data-id="element-52">
                  {faq.q}
                </h4>
                <p className="text-slate-300 text-lg font-light leading-relaxed" data-id="element-53">
                  {faq.a}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}